import TextView from "../textview/TextView";
import RatingBar from "../ratingbar/RatingBar";
import LinearLayout from "../layout/LinearLayout";
import "./ProductCard.css";
const ProductCardDesktop = ({ image, title, price, rating }) => {
  return (
    <LinearLayout
      height="320px"
      width="270px"
      className="card me-5 shadow-lg border-0 p-1 product-card"
      margin={0}
    >
      <img
        src={image}
        alt={title}
        className="card-img-top img-thumbnail border-none"
        style={{ height: "150px",  objectFit: "fill" }}
      />

      <div className="card-body">
        <TextView text={title} size="sm" bold={false}   />
        <div className="my-2">
          <RatingBar value={rating} />
        </div>
        <TextView text={`${price}$`} size="sm" color="success" bold={true} />
      </div>
    </LinearLayout>
  );
};

export default ProductCardDesktop;
//   <LinearLayout height="350px" width="300px" className="card shadow-sm border-0" margin={0}>
//         <img
//           src={image}
//           alt={title}
//           className="card-img-top"
//           style={{ height: "180px", objectFit: "contain" }}
//         />

//         <div className="card-body">
//           <TextView text={title} size="sm" bold={false} />
//           <div className="my-2">
//             <RatingBar value={rating} />
//           </div>
//           <TextView text={`${price}`} size="lg" color="success" bold={true} />
//         </div>
//       </LinearLayout>